/* src/app/views/contract-summary-external/contract-summary-external.component.scss */
:host {
  --summary-surface-soft: #ffffff;
  --summary-border-subtle: #d9e1ec;
  --summary-shadow: 0 14px 32px rgba(18, 38, 63, 0.1);
  --summary-left-anchor: 40px;
  --summary-text-primary: #1b2538;
  --summary-text-secondary: #5f5f5f;
  --summary-text-tertiary: #9aa4b2;
  --summary-border-input: #b8c1cc;
  --summary-focus-border: #8ea6c9;
  --summary-focus-shadow: rgba(142, 166, 201, 0.18);
}
.container {
  background: var(--summary-surface-soft);
  border: 1px solid var(--summary-border-subtle);
  border-radius: 14px;
  box-shadow: var(--summary-shadow);
  padding: 6px 0 20px;
}
@media (max-width: 640px) {
  .container {
    padding: 4px 0 16px;
  }
}
.summary-content-shell {
  padding: clamp(20px, 3vw, 32px);
  background: var(--summary-surface-soft);
}
@media (max-width: 640px) {
  .summary-content-shell {
    padding: clamp(14px, 2.5vw, 18px);
  }
}
.summary-content {
  width: 100%;
}
.summary-section-block {
  margin: 0 0 clamp(20px, 2.5vw, 28px);
  background: var(--summary-surface-soft);
  border: 1px solid var(--summary-border-subtle);
  border-radius: 14px;
  padding: 0;
  box-shadow: var(--summary-shadow);
}
@media (max-width: 640px) {
  .summary-section-block {
    margin: 0 0 clamp(14px, 2vw, 18px);
  }
}
.summary-section-inner {
  padding: clamp(18px, 2.5vw, 24px) clamp(18px, 3vw, 28px);
}
@media (max-width: 640px) {
  .summary-section-inner {
    padding: clamp(14px, 2.2vw, 16px) clamp(14px, 2.5vw, 16px);
  }
}
.summary-section-title {
  font-size: clamp(16px, 2vw, 20px);
  font-weight: 500;
  color: var(--summary-text-primary);
  margin: 0 0 clamp(14px, 1.8vw, 18px);
  line-height: 1.3;
}
@media (max-width: 640px) {
  .summary-section-title {
    font-size: clamp(14px, 1.8vw, 16px);
    margin: 0 0 clamp(10px, 1.5vw, 12px);
  }
}
.vehicle-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: clamp(18px, 2.5vw, 24px);
  align-items: stretch;
}
@media (max-width: 1024px) {
  .vehicle-grid {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
  }
  .vehicle-grid .vehicle-image-col {
    grid-column: 1/-1;
    order: -1;
    margin-bottom: clamp(4px, 1vw, 8px);
  }
}
@media (max-width: 640px) {
  .vehicle-grid {
    grid-template-columns: 1fr;
    gap: clamp(14px, 2vw, 16px);
  }
  .vehicle-grid .vehicle-image-col {
    grid-column: 1;
    order: -1;
    margin-bottom: clamp(6px, 1.5vw, 10px);
  }
}
.vehicle-col {
  display: flex;
  flex-direction: column;
  gap: clamp(12px, 2vw, 16px);
  justify-content: flex-start;
  flex: 1;
}
@media (max-width: 640px) {
  .vehicle-col {
    gap: clamp(10px, 1.8vw, 14px);
  }
}
.vehicle-info-pair {
  display: flex;
  flex-direction: column;
  gap: clamp(6px, 0.8vw, 8px);
  padding: clamp(14px, 2vw, 18px);
  background:
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(249, 250, 252, 0.8) 100%);
  border: 1px solid rgba(217, 225, 236, 0.4);
  border-radius: 10px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.vehicle-info-pair:hover {
  background:
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.8) 0%,
      rgb(249, 250, 252) 100%);
  border-color: rgba(142, 166, 201, 0.2);
  box-shadow: 0 4px 12px rgba(18, 38, 63, 0.05);
}
.vehicle-info-pair--left,
.vehicle-info-pair--right {
  width: 100%;
}
.vehicle-info-key {
  font-size: clamp(10px, 1vw, 11px);
  font-weight: 600;
  color: var(--summary-text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.4px;
  line-height: 1.2;
}
.vehicle-info-val {
  font-size: clamp(14px, 1.5vw, 16px);
  color: var(--summary-text-primary);
  font-weight: 600;
  word-break: break-word;
  line-height: 1.5;
}
.vehicle-image-col {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(16px, 2.2vw, 20px);
  background:
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(249, 250, 252, 0.8) 100%);
  border: 1px solid rgba(217, 225, 236, 0.4);
  border-radius: 10px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: clamp(140px, 25vw, 200px);
}
.vehicle-image-col:hover {
  background:
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.8) 0%,
      rgb(249, 250, 252) 100%);
  border-color: rgba(142, 166, 201, 0.2);
  box-shadow: 0 4px 12px rgba(18, 38, 63, 0.05);
}
@media (max-width: 640px) {
  .vehicle-image-col {
    min-height: clamp(120px, 30vw, 160px);
  }
}
.vehicle-summary-image {
  max-width: clamp(110px, 18vw, 200px);
  max-height: clamp(110px, 18vw, 200px);
  object-fit: contain;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.08));
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.vehicle-summary-image:hover {
  transform: scale(1.05);
}
.contract-container {
  display: flex;
  flex-direction: column;
  gap: clamp(16px, 2.2vw, 20px);
}
.contract-section {
  display: flex;
  flex-direction: column;
  gap: clamp(12px, 1.8vw, 16px);
}
.contract-header {
  display: flex;
  align-items: center;
  gap: clamp(8px, 1.2vw, 10px);
  font-size: clamp(13px, 1.3vw, 15px);
  font-weight: 600;
  color: var(--summary-text-primary);
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.contract-items {
  display: flex;
  flex-direction: column;
  gap: clamp(10px, 1.6vw, 14px);
}
.contract-item {
  display: flex;
  flex-direction: column;
  gap: clamp(4px, 0.6vw, 6px);
  padding: clamp(14px, 2vw, 18px);
  background:
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(249, 250, 252, 0.8) 100%);
  border: 1px solid rgba(217, 225, 236, 0.4);
  border-radius: 10px;
  font-size: clamp(13px, 1.3vw, 14px);
  color: var(--summary-text-primary);
  line-height: 1.5;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.contract-item:hover {
  background:
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.8) 0%,
      rgb(249, 250, 252) 100%);
  border-color: rgba(142, 166, 201, 0.2);
  box-shadow: 0 4px 12px rgba(18, 38, 63, 0.05);
}
.contract-grid {
  display: flex;
  flex-direction: column;
  gap: 0;
  background:
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(249, 250, 252, 0.8) 100%);
  border: 1px solid rgba(217, 225, 236, 0.4);
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.contract-grid:hover {
  background:
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.8) 0%,
      rgb(249, 250, 252) 100%);
  border-color: rgba(142, 166, 201, 0.2);
  box-shadow: 0 4px 12px rgba(18, 38, 63, 0.05);
}
.contract-item-row {
  display: grid;
  grid-template-columns: 2fr 1.2fr 1.2fr 1.5fr;
  gap: clamp(12px, 1.8vw, 16px);
  align-items: center;
  padding: clamp(16px, 2.2vw, 20px);
  background: transparent;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid rgba(217, 225, 236, 0.4);
  transition: all 0.2s ease;
}
.contract-item-row:last-child {
  border-bottom: none;
}
.contract-item-row:hover {
  background: rgba(249, 250, 252, 0.5);
}
@media (max-width: 1024px) {
  .contract-item-row {
    grid-template-columns: 1.8fr 1fr 1fr 1.3fr;
    gap: clamp(10px, 1.6vw, 14px);
    padding: clamp(14px, 2vw, 18px);
  }
}
@media (max-width: 640px) {
  .contract-item-row {
    grid-template-columns: 1fr;
    gap: clamp(10px, 1.5vw, 12px);
    padding: clamp(14px, 2vw, 16px);
  }
  .contract-item-row .item-time,
  .contract-item-row .item-distance {
    display: none;
  }
}
.item-name,
.item-time,
.item-distance,
.item-price {
  font-size: clamp(13px, 1.3vw, 14px);
  color: var(--summary-text-primary);
  line-height: 1.5;
  word-break: break-word;
}
.item-name {
  font-weight: 600;
  color: var(--summary-text-primary);
  flex: 1;
}
@media (max-width: 640px) {
  .item-name {
    font-size: clamp(14px, 1.4vw, 15px);
  }
}
.item-time,
.item-distance {
  font-weight: 500;
  color: var(--summary-text-secondary);
  text-align: center;
  font-size: clamp(12px, 1.2vw, 13px);
}
@media (max-width: 1024px) {
  .item-time,
  .item-distance {
    text-align: left;
  }
}
@media (max-width: 640px) {
  .item-time,
  .item-distance {
    font-size: clamp(12px, 1.1vw, 13px);
  }
}
.item-price {
  font-weight: 700;
  color: #0066cc;
  text-align: right;
  font-size: clamp(13px, 1.4vw, 15px);
}
@media (max-width: 640px) {
  .item-price {
    text-align: left;
    font-size: clamp(14px, 1.5vw, 16px);
  }
}
.contract-grid .contract-total {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: clamp(14px, 2.2vw, 18px);
  align-items: center;
  padding: clamp(16px, 2.2vw, 20px);
  background: rgba(249, 250, 252, 0.7);
  border: none;
  border-top: 1px solid rgba(217, 225, 236, 0.4);
  border-radius: 0;
  margin-top: 0;
  transition: all 0.2s ease;
}
.contract-grid .contract-total:hover {
  background: rgba(249, 250, 252, 0.9);
}
.contract-total {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: clamp(14px, 2.2vw, 18px);
  align-items: center;
  padding: clamp(16px, 2.2vw, 20px);
  background:
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(249, 250, 252, 0.8) 100%);
  border: 1px solid rgba(217, 225, 236, 0.4);
  border-radius: 10px;
  margin-top: clamp(12px, 1.8vw, 16px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.contract-total:hover {
  background:
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.8) 0%,
      rgb(249, 250, 252) 100%);
  border-color: rgba(142, 166, 201, 0.2);
  box-shadow: 0 4px 12px rgba(18, 38, 63, 0.05);
}
.total-label {
  font-size: clamp(12px, 1.2vw, 13px);
  font-weight: 700;
  color: var(--summary-text-primary);
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.total-value {
  font-size: clamp(16px, 1.6vw, 18px);
  font-weight: 600;
  color: #0066cc;
  text-align: right;
}
.client-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: clamp(12px, 2vw, 16px);
}
@media (max-width: 640px) {
  .client-grid {
    grid-template-columns: 1fr;
    gap: clamp(10px, 1.5vw, 12px);
  }
}
.client-field {
  display: flex;
  flex-direction: column;
  gap: clamp(6px, 1vw, 8px);
  padding: clamp(14px, 2vw, 18px);
  background:
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(249, 250, 252, 0.8) 100%);
  border: 1px solid rgba(217, 225, 236, 0.4);
  border-radius: 10px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.client-field:hover {
  background:
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.8) 0%,
      rgb(249, 250, 252) 100%);
  border-color: rgba(142, 166, 201, 0.2);
  box-shadow: 0 4px 12px rgba(18, 38, 63, 0.05);
}
.client-field--full {
  grid-column: span 6;
}
.client-field--col-3 {
  grid-column: span 2;
}
.client-field--col-2 {
  grid-column: span 3;
}
@media (max-width: 640px) {
  .client-field--col-3,
  .client-field--col-2 {
    grid-column: span 1;
  }
}
.client-info-key {
  font-size: clamp(10px, 1vw, 11px);
  font-weight: 600;
  color: var(--summary-text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.4px;
  line-height: 1.2;
}
.client-info-val {
  font-size: clamp(13px, 1.3vw, 15px);
  color: var(--summary-text-primary);
  font-weight: 600;
  word-break: break-word;
  line-height: 1.5;
}
.summary-section-inner:has(.section-box-title) {
  display: flex;
  flex-direction: column;
  gap: clamp(14px, 2vw, 18px);
  padding: clamp(18px, 2.5vw, 24px);
  background:
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(249, 250, 252, 0.8) 100%);
  border: 1px solid rgba(217, 225, 236, 0.4);
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.summary-section-inner:has(.section-box-title):hover {
  background:
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.8) 0%,
      rgb(249, 250, 252) 100%);
  border-color: rgba(142, 166, 201, 0.2);
  box-shadow: 0 4px 12px rgba(18, 38, 63, 0.05);
}
.section-box-title {
  font-size: clamp(13px, 1.3vw, 15px);
  font-weight: 700;
  color: var(--summary-text-primary);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding-bottom: clamp(8px, 1.2vw, 10px);
  border-bottom: 1px solid rgba(217, 225, 236, 0.4);
}
.dealer-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: clamp(12px, 2vw, 16px);
}
@media (max-width: 640px) {
  .dealer-grid {
    grid-template-columns: 1fr;
    gap: clamp(10px, 1.5vw, 12px);
  }
}
.dealer-field {
  display: flex;
  flex-direction: column;
  gap: clamp(6px, 1vw, 8px);
}
.dealer-field input,
.dealer-field p-inputMask ::ng-deep input {
  height: 44px !important;
  padding: clamp(10px, 1.6vw, 12px) 14px !important;
  border-radius: 12px !important;
  font-size: clamp(13px, 1.3vw, 15px) !important;
  border: 1px solid var(--summary-border-input) !important;
  background: var(--summary-surface-soft) !important;
  color: var(--summary-text-primary) !important;
  transition: all 0.2s ease !important;
}
.dealer-field input:focus,
.dealer-field p-inputMask ::ng-deep input:focus {
  outline: none !important;
  border-color: var(--summary-focus-border) !important;
  box-shadow: 0 0 0 3px var(--summary-focus-shadow) !important;
}
.dealer-field input::placeholder,
.dealer-field p-inputMask ::ng-deep input::placeholder {
  color: var(--summary-text-tertiary) !important;
}
.dealer-field-full {
  display: flex;
  flex-direction: column;
  gap: clamp(6px, 1vw, 8px);
}
.dealer-field-full input {
  height: 44px !important;
  padding: clamp(10px, 1.6vw, 12px) 14px !important;
  border-radius: 12px !important;
  font-size: clamp(13px, 1.3vw, 15px) !important;
  border: 1px solid var(--summary-border-input) !important;
  background: var(--summary-surface-soft) !important;
  color: var(--summary-text-primary) !important;
  transition: all 0.2s ease !important;
  width: 100% !important;
}
.dealer-field-full input:focus {
  outline: none !important;
  border-color: var(--summary-focus-border) !important;
  box-shadow: 0 0 0 3px var(--summary-focus-shadow) !important;
}
.dealer-field-full input::placeholder {
  color: var(--summary-text-tertiary) !important;
}
.seller-section {
  display: flex;
  flex-direction: column;
  gap: clamp(10px, 1.6vw, 14px);
  padding-top: clamp(12px, 2vw, 16px);
  border-top: 1px solid var(--summary-border-subtle);
}
.seller-section-title {
  font-size: clamp(13px, 1.3vw, 15px);
  font-weight: 500;
  color: var(--summary-text-primary);
  text-transform: uppercase;
  letter-spacing: 0.2px;
  line-height: 1.2;
}
.seller-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: clamp(12px, 2vw, 16px);
}
@media (max-width: 640px) {
  .seller-grid {
    grid-template-columns: 1fr;
    gap: clamp(10px, 1.5vw, 12px);
  }
}
.seller-field {
  display: flex;
  flex-direction: column;
  gap: clamp(6px, 1vw, 8px);
}
.seller-field input,
.seller-field p-inputMask ::ng-deep input {
  height: 44px !important;
  padding: clamp(10px, 1.6vw, 12px) 14px !important;
  border-radius: 12px !important;
  font-size: clamp(13px, 1.3vw, 15px) !important;
  border: 1px solid var(--summary-border-input) !important;
  background: var(--summary-surface-soft) !important;
  color: var(--summary-text-primary) !important;
  transition: all 0.2s ease !important;
}
.seller-field input:focus,
.seller-field p-inputMask ::ng-deep input:focus {
  outline: none !important;
  border-color: var(--summary-focus-border) !important;
  box-shadow: 0 0 0 3px var(--summary-focus-shadow) !important;
}
.seller-field input::placeholder,
.seller-field p-inputMask ::ng-deep input::placeholder {
  color: var(--summary-text-tertiary) !important;
}
.summary-section-inner:has(.payment-container) {
  display: flex;
  flex-direction: column;
  gap: clamp(14px, 2vw, 18px);
  padding: clamp(18px, 2.5vw, 24px);
  background:
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(249, 250, 252, 0.8) 100%);
  border: 1px solid rgba(217, 225, 236, 0.4);
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.summary-section-inner:has(.payment-container):hover {
  background:
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.8) 0%,
      rgb(249, 250, 252) 100%);
  border-color: rgba(142, 166, 201, 0.2);
  box-shadow: 0 4px 12px rgba(18, 38, 63, 0.05);
}
.payment-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: clamp(14px, 2vw, 18px);
}
@media (max-width: 1024px) {
  .payment-container {
    grid-template-columns: repeat(2, 1fr);
    gap: clamp(12px, 2vw, 16px);
  }
}
@media (max-width: 640px) {
  .payment-container {
    grid-template-columns: 1fr;
    gap: clamp(10px, 1.5vw, 12px);
  }
}
.payment-field {
  display: flex;
  flex-direction: column;
  gap: clamp(8px, 1.2vw, 10px);
  padding: clamp(12px, 1.8vw, 14px);
  background: rgba(255, 255, 255, 0.4);
  border: 1px solid rgba(217, 225, 236, 0.3);
  border-radius: 8px;
  transition: all 0.2s ease;
}
.payment-field:hover {
  background: rgba(255, 255, 255, 0.6);
  border-color: rgba(142, 166, 201, 0.15);
}
.summary-form-label {
  font-size: clamp(11px, 1.1vw, 12px);
  font-weight: 500;
  color: var(--summary-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.2px;
  margin-bottom: clamp(3px, 0.5vw, 4px);
  line-height: 1.2;
}
:host ::ng-deep input[type=text],
:host ::ng-deep input[type=email],
:host ::ng-deep p-inputText input,
:host ::ng-deep p-inputMask input {
  height: 44px !important;
  padding: clamp(10px, 1.6vw, 12px) 14px !important;
  font-size: clamp(13px, 1.3vw, 15px) !important;
  border-radius: 12px !important;
  border: 1px solid var(--summary-border-input) !important;
  background: var(--summary-surface-soft) !important;
  color: var(--summary-text-primary) !important;
  transition: all 0.2s ease !important;
}
:host ::ng-deep input[type=text]:focus,
:host ::ng-deep input[type=email]:focus,
:host ::ng-deep p-inputText input:focus,
:host ::ng-deep p-inputMask input:focus {
  outline: none !important;
  border-color: var(--summary-focus-border) !important;
  box-shadow: 0 0 0 3px var(--summary-focus-shadow) !important;
}
:host ::ng-deep input[type=text]::placeholder,
:host ::ng-deep input[type=email]::placeholder,
:host ::ng-deep p-inputText input::placeholder,
:host ::ng-deep p-inputMask input::placeholder {
  color: var(--summary-text-tertiary) !important;
}
@media (max-width: 640px) {
  :host ::ng-deep input[type=text],
  :host ::ng-deep input[type=email],
  :host ::ng-deep p-inputText input,
  :host ::ng-deep p-inputMask input {
    height: 42px !important;
    font-size: clamp(12px, 1.2vw, 13px) !important;
  }
}
:host ::ng-deep p-dropdown {
  width: 100% !important;
}
:host ::ng-deep p-dropdown .p-dropdown-trigger {
  width: 32px;
}
:host ::ng-deep p-dropdown .p-dropdown-label {
  height: 44px !important;
  padding: clamp(10px, 1.6vw, 12px) 14px !important;
  font-size: clamp(13px, 1.3vw, 15px) !important;
  border-radius: 12px !important;
  border: 1px solid var(--summary-border-input) !important;
  background: var(--summary-surface-soft) !important;
  color: var(--summary-text-primary) !important;
  transition: all 0.2s ease !important;
  line-height: 22px !important;
}
:host ::ng-deep p-dropdown .p-dropdown-label:focus {
  outline: none !important;
  border-color: var(--summary-focus-border) !important;
  box-shadow: 0 0 0 3px var(--summary-focus-shadow) !important;
}
:host ::ng-deep p-dropdown .p-dropdown:focus {
  border-color: var(--summary-focus-border) !important;
  box-shadow: 0 0 0 3px var(--summary-focus-shadow) !important;
}
:host ::ng-deep p-message {
  width: 100% !important;
  margin-top: clamp(4px, 0.8vw, 6px) !important;
  font-size: clamp(11px, 1.1vw, 12px) !important;
}
:host ::ng-deep p-message ::ng-deep .p-message-text {
  color: #d73a49 !important;
  font-weight: 400 !important;
}
.p-fluid {
  width: 100%;
}
.p-fluid input,
.p-fluid select,
.p-fluid textarea {
  width: 100%;
}
.fluid {
  width: 100%;
}
.client-data-message {
  display: block;
  width: 100%;
  margin-top: clamp(4px, 0.8vw, 6px) !important;
}
.summary-value {
  font-size: clamp(13px, 1.3vw, 15px);
  color: var(--summary-text-primary);
  font-weight: 500;
  line-height: 1.4;
}
.dealer-name-value {
  padding: clamp(10px, 1.6vw, 12px) 14px;
  background: var(--summary-surface-soft);
  border-radius: 12px;
  border: 1px solid var(--summary-border-subtle);
  display: block;
  height: 44px;
  line-height: 22px;
}
.margin-top-5 {
  margin-top: clamp(12px, 2vw, 16px);
}
.summary-inline-heading {
  display: inline-block;
  background: transparent;
  margin-top: clamp(4px, 1vw, 6px);
  margin-bottom: 0;
  font-size: clamp(13px, 1.3vw, 15px);
  font-weight: 500;
  color: var(--summary-text-primary);
  line-height: 1.3;
}
.summary-inline-heading--section {
  display: block;
  border-bottom: 1px solid var(--summary-border-subtle);
  padding-bottom: clamp(6px, 1vw, 8px);
  margin: clamp(10px, 1.6vw, 14px) 0 clamp(8px, 1.4vw, 10px) 0;
}
.contract-section .summary-inline-heading {
  margin: 0;
  padding-bottom: 0;
  border-bottom: none;
}
.btn-consult,
.btn-return {
  width: 137px;
  height: 50px;
  border-radius: 12px;
  margin-top: 0;
  margin-right: 0;
}
.btn-consult {
  background: #046cea;
  border: 1px solid #046cea;
}
.btn-consult-label {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
}
.btn-return {
  background: #ffffff;
  border: 1px solid #046cea;
}
.btn-return-label {
  font-size: 15pt;
  font-weight: 500;
  color: #046cea;
  margin-left: 5px;
}
.btn-consult:hover:not(:disabled),
.btn-return:hover:not(:disabled) {
  background: #044ea7;
}
.btn-consult:disabled,
.btn-return:disabled {
  background: #e5e5e5;
  border-color: #aaaaaa;
  cursor: not-allowed;
  opacity: 0.7;
}
.btn-consult:disabled .btn-consult-label,
.btn-return:disabled .btn-return-label,
.btn-consult:disabled .pi,
.btn-return:disabled .pi {
  color: #202020;
}
button.btn-return:hover .btn-return-label {
  color: #ffffff;
}
.button-position .btn-return,
.button-position .btn-consult {
  margin-top: 0 !important;
  margin-right: 0 !important;
}
.client-data-preform-actions .btn-return {
  margin-top: 0 !important;
  margin-right: 0 !important;
}
@media only screen and (max-width: 900px) {
  .button-position {
    margin-left: 20px;
    width: calc(100% - 20px);
    justify-content: flex-start;
  }
  .button-position .undo-action-button,
  .button-position .undo-action-button.return,
  :host ::ng-deep .button-position app-cta-button button {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
  }
}
@media only screen and (max-width: 640px) {
  .button-position {
    margin-left: 8px;
    width: calc(100% - 8px);
    margin-top: 12px;
    justify-content: flex-end;
  }
  .button-position .undo-action-button,
  .button-position .undo-action-button.return,
  :host ::ng-deep .button-position app-cta-button button {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    margin-top: 10px !important;
  }
}
/*# sourceMappingURL=contract-summary-external.component-7VGTU7ET.css.map */
